import * as React from "react";

const IconHeaderUtilityDropdownDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 8 5">
            <path
                fill="currentColor"
                d="M4 4.375a.653.653 0 0 1-.442-.167L.433 1.35a.537.537 0 0 1 0-.808.667.667 0 0 1 .884 0L4 2.996 6.683.543a.667.667 0 0 1 .884 0 .537.537 0 0 1 0 .808L4.442 4.208A.654.654 0 0 1 4 4.375z"
            />
        </svg>
    );
};
export default React.memo(IconHeaderUtilityDropdownDown);
